import { render, staticRenderFns } from "./PagamentoDeFornecedores.vue?vue&type=template&id=1c4a6a88&scoped=true&"
import script from "./PagamentoDeFornecedores.vue?vue&type=script&lang=js&"
export * from "./PagamentoDeFornecedores.vue?vue&type=script&lang=js&"
import style0 from "./PagamentoDeFornecedores.vue?vue&type=style&index=0&id=1c4a6a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a6a88",
  null
  
)

component.options.__file = "PagamentoDeFornecedores.vue"
export default component.exports